// extracted by mini-css-extract-plugin
export var planCard = "_uj-0";
export var planList = "_uj-1";